(function () {
  var toggle = document.getElementById('FCartToggle');
  var backdrop = document.getElementById('FCartBackdrop');
  var drawer = document.getElementById('FCartDrawer');
  var closeBtn = document.getElementById('FCartClose');
  var itemsWrap = document.getElementById('FCartDrawerItems');
  var subtotalEl = document.getElementById('FCartDrawerSubtotal');
  var countEl = document.getElementById('FCartCount');
  if (!toggle || !backdrop || !drawer) return;

  var tabs = drawer.querySelectorAll('[data-cart-drawer-tab]');
  var panels = drawer.querySelectorAll('[data-cart-drawer-panel]');

  function setTab(name) {
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-cart-drawer-tab') === name); });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-cart-drawer-panel') !== name; });
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { setTab(t.getAttribute('data-cart-drawer-tab')); });
  });

  function closeNav() {
    var navPanel = document.getElementById('FNavPanel');
    var navBackdrop = document.getElementById('FNavBackdrop');
    var navToggle = document.getElementById('FNavToggle');
    if (navPanel) navPanel.classList.remove('is-open');
    if (navBackdrop) navBackdrop.classList.remove('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
  }

  function setOpen(open) {
    if (open) closeNav();
    if (!open) document.dispatchEvent(new CustomEvent('cart:closed'));
    drawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  toggle.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });
  backdrop.addEventListener('click', function () { setOpen(false); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

  function formatMoney(cents) {
    // Preferred: mimic Shopify's {{ amount | money }} using a formatted sample (see layout/theme.liquid).
    var p = /^(\D*?)1(\D?)234(\D?)567(\D)89(\D*)$/.exec(String(window.FIORENCI_MONEY_SAMPLE || ''));
    if (p) {
      var abs = Math.abs(cents), whole = String(Math.floor(abs / 100)), frac = ('0' + (abs % 100)).slice(-2);
      if (p[2]) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, p[2]);
      return p[1] + (cents < 0 ? '-' : '') + whole + p[4] + frac + p[5];
    }
    var currency = window.FIORENCI_CURRENCY || 'USD';
    var lang = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function updateCartCount(count) {
    if (!countEl) return;
    countEl.textContent = count;
    countEl.hidden = count <= 0;
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Display-time size normalisation, same rule as snippets/size-label.liquid ("100ml" -> "100 ml").
  function normSize(s) {
    s = String(s || '').trim();
    if (!/^\d/.test(s)) return s;
    return s.replace(/(ml|cl|oz)/gi, function (u) { return ' ' + u.toLowerCase(); }).replace(/\s{2,}/g, ' ').trim();
  }

  // Stock facts for the current cart lines: Shopify's Section Rendering API renders sections/cart-stock.liquid with the current cart.
  function fetchStock() {
    return fetch(route('') + '?section_id=cart-stock&_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        var m = /<script[^>]*id="FCartStockData"[^>]*>([\s\S]*?)<\/script>/.exec(html);
        return m ? JSON.parse(m[1]) : null;
      })
      .catch(function () { return null; });
  }
  function lowText(n) {
    var S = window.FIORENCI_STRINGS || {};
    return (n === 1 ? S.lowStockOne : String(S.lowStockOther || '').replace('99999', String(n))) || '';
  }
  function renderWithStock(cart) {
    return fetchStock().then(function (stock) { renderCart(cart, stock); });
  }

  function renderCart(cart, stock) {
    if (!itemsWrap) return;

    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="f-pdp-tab-panel__empty">' + escapeHtml(window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.cartEmpty) + '</p>';
    } else {
      itemsWrap.innerHTML = cart.items.map(function (item) {
        var st = stock && stock.items && stock.items[item.variant_id];
        var maxUnits = st && st.max != null ? st.max : null;
        var atMax = maxUnits != null && item.quantity >= maxUnits;
        return (
          '<div class="f-cart-drawer__item" data-cart-item-key="' + item.key + '"' + (maxUnits != null ? ' data-max="' + maxUnits + '"' : '') + '>' +
            '<a href="' + item.url + '" class="f-cart-drawer__item-media">' +
              (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="f-cart-drawer__item-body">' +
              '<p class="f-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="f-cart-drawer__item-variant">' + escapeHtml(normSize(item.variant_title)) + '</p>' : '') +
              (st && st.low > 0 ? '<p class="f-cart-drawer__item-low">' + escapeHtml(lowText(st.low)) + '</p>' : '') +
              '<p class="f-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
              '<div class="f-cart-drawer__item-qty">' +
                '<div class="f-qty f-qty--sm">' +
                  '<button type="button" class="f-qty__btn" data-cart-qty="-1" aria-label="' + escapeHtml(window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.qtyDecrease) + '">−</button>' +
                  '<span class="f-qty__value" aria-live="polite">' + item.quantity + '</span>' +
                  '<button type="button" class="f-qty__btn" data-cart-qty="1" aria-label="' + escapeHtml(window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.qtyIncrease) + '"' + (atMax ? ' disabled' : '') + '>+</button>' +
                '</div>' +
                '<button type="button" class="f-cart-drawer__item-remove" data-cart-remove>' + escapeHtml(window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.remove) + '</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateShipHint(cart);
    updateCartCount(cart.item_count);
  }

  // Shipping hint under the subtotal (same rules as snippets/shipping-hint.liquid): below the threshold "Add X more for Y shipping" + a partly
  // filled bar, from the threshold "You've unlocked Y shipping" + a full bar; hidden for an empty cart or another currency.
  function formatWhole(cents) {
    var p = /^(\D*?)1(\D?)234(\D?)567(\D)89(\D*)$/.exec(String(window.FIORENCI_MONEY_SAMPLE || ''));
    var whole = String(Math.ceil(Math.abs(cents) / 100));
    if (p) { if (p[2]) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, p[2]); return (p[1] + whole + p[5]).replace(/ /g, ' '); }   // no line break between the number and "kr"
    return formatMoney(Math.ceil(cents / 100) * 100);
  }
  function updateShipHint(cart) {
    var S = window.FIORENCI_SHIP, box = drawer.querySelector('[data-ship-hint]');
    if (!box) return;
    var show = !!(S && S.on && S.threshold > 0 && cart.item_count > 0 && (!cart.currency || cart.currency === S.currency));
    box.hidden = !show;
    if (!show) return;
    var unlocked = cart.total_price >= S.threshold;
    var pct = unlocked ? 100 : Math.floor(cart.total_price * 100 / S.threshold);
    var text = unlocked ? S.unlocked : S.add.replace('__AMOUNT__', formatWhole(S.threshold - cart.total_price));
    var textEl = box.querySelector('[data-ship-text]'), fill = box.querySelector('[data-ship-bar] span');
    if (textEl && textEl.textContent !== text) textEl.textContent = text;
    if (fill) fill.style.width = pct + '%';
  }

  // Cart API URLs go through Shopify.routes.root ("/" in English, "/sv/" in Swedish): a plain "/cart.js" answers with the English product
  // links (item.url), so the drawer's product links would leave the Swedish site.
  function route(path) { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path; }

  function fetchCart() {
    return fetch(route('cart.js')).then(function (res) { return res.json(); }).then(renderWithStock);
  }

  function changeItem(key, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        // 422 (e.g. more than is in stock) answers with an error object, not a cart: re-read the real cart instead.
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) return fetchCart();
        return renderWithStock(r.data).then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); });
      });
  }

  if (itemsWrap) {
    itemsWrap.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-item-key]');
      if (!row) return;
      var key = row.getAttribute('data-cart-item-key');

      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var span = row.querySelector('.f-qty__value');
        var current = parseInt(span.textContent, 10) || 1;
        var next = current + parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
        if (next < 0) next = 0;
        var cap = parseInt(row.getAttribute('data-max'), 10);
        if (!isNaN(cap) && next > cap) return;   // never more than is in stock (tracked variants)
        changeItem(key, next);
        return;
      }

      if (e.target.closest('[data-cart-remove]')) {
        changeItem(key, 0);
      }
    });
  }

  document.addEventListener('cart:updated', function () {
    fetchCart();
    setOpen(true);
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart();

    // Reopen the Wishlist tab after Shopify's hosted sign-in sends the visitor
    // back. The flag is read AND cleared on every page load, so it can only
    // ever act on the first load after clicking "Sign in": it opens the drawer
    // only if the visitor is now signed in and the flag is under 15 minutes
    // old; if they came back signed out (cancelled), it's just discarded.
    var flag = null;
    try {
      flag = JSON.parse(sessionStorage.getItem(REOPEN_KEY));
      sessionStorage.removeItem(REOPEN_KEY);
    } catch (e) { flag = null; }
    var signedIn = drawer.getAttribute('data-signed-in') === 'true';
    if (flag && flag.tab === 'wishlist' && signedIn && Date.now() - flag.t < 15 * 60 * 1000) {
      setTab('wishlist');
      setOpen(true);
    }
  });

  // Remember, just before leaving for the hosted sign-in page, that the drawer
  // should come back open on the Wishlist tab (the page itself is reloaded).
  var REOPEN_KEY = 'fiorenci_reopen_drawer';
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-signin-link]')) return;
    try { sessionStorage.setItem(REOPEN_KEY, JSON.stringify({ tab: 'wishlist', t: Date.now() })); } catch (err) {}
  });
})();
